//STORE PRINCIPAL

// importando librerias
import Vue from 'vue'
import Vuex from 'vuex'

// Importando metodos de store
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'




Vue.use(Vuex)

// Creando el objeto store
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
  
  
})

export default store;
